// extracted by mini-css-extract-plugin
export var image = "art-directed-image-module--image--8c45a";
export var picture = "art-directed-image-module--picture--14796";
export var placeholder = "art-directed-image-module--placeholder--236f0";
export var placeholderHidden = "art-directed-image-module--placeholderHidden--175c9";
export var wrapper = "art-directed-image-module--wrapper--6c4d5";